import { useEffect } from 'react'
import { useAuth0 } from './auth-provider'

export function AuthGuard({ children }) {
  const {
    logout,
    isAuthenticated,
    isLoading,
    error,
    user,
    getAccessTokenSilently,
  } = useAuth0()

  const handleTestFlagRemove = () => {
    localStorage.removeItem('tester_email')
  }

  useEffect(() => {
    addEventListener('LOGOUT_EVENT', handleTestFlagRemove)
    return () => handleTestFlagRemove()
  }, [])

  const handleLogout = () => {
    const event = new CustomEvent('LOGOUT_EVENT')
    window.dispatchEvent(event)
    localStorage.removeItem('token')
    handleTestFlagRemove()
    localStorage.removeItem('headers')
    localStorage.removeItem('UI_CONFIG')
    localStorage.removeItem('sub')
    localStorage.removeItem('isTesting')
    localStorage.removeItem('x-organization-code')
    logout()
  }

  useEffect(() => {
    if (error) {
      handleLogout()
    }
  }, [error])

  const handleToken = async () => {
    try {
      const token = await getAccessTokenSilently()

      if (!token) {
        handleLogout()
      }
    } catch (err) {
      handleLogout()
    }
  }

  useEffect(() => {
    user && localStorage.setItem('sub', user.sub)
  }, [user])

  useEffect(() => {
    const organization = user && user[process.env.ORGANIZATION_CODE]
    const users = user && user[process.env.USER_CODE]
    if (isAuthenticated && (!organization || !users)) {
      handleLogout()
    }

    if (user?.email) {
      localStorage.setItem('tester_email', user?.email)
    }

    if (!user) {
      handleTestFlagRemove()
    }

    if (error?.message.includes('emailVerify')) {
      const urlParams = new URLSearchParams(error.message)
      const userEmail = urlParams.get('email')
      window.location.href = `${window.location.origin}/auth?emailError=true&user=${userEmail}`
    }

    if (
      !isAuthenticated &&
      !isLoading &&
      !error?.message.includes('emailVerify')
    ) {
      handleToken()
    }
  }, [isAuthenticated, isLoading])

  return children
}
